import axios from '../../http.service';
import cloneDeep from 'lodash/cloneDeep';
import * as TYPES from '../Enums/Contract.Fees.Enums';

export const getContractFeesCount = (contractTypes, year) => {
	return async dispatch => {
		try {
			let resp = await axios.get(`/api/v2/contracts/fees/count/${year}/${JSON.stringify(contractTypes)}`);

			if (resp.status === 200)
				dispatch({
					type: TYPES.CONTRACT_FEES_COUNT,
					payload: resp.data
				});
			else
				dispatch({
					type: TYPES.CONTRACT_FEES_ERROR,
					payload: resp.data
				});
		} catch (error) {
			dispatch({
				type: TYPES.CONTRACT_FEES_ERROR,
				payload: { data: [], errors: [error.message] }
			});
		}
	};
};

export const getContractFees = (contractTypes, year, query, exportData = false) => {
	return async (dispatch, getState) => {
		try {
			let resp = await axios.get(`/api/v2/contracts/fees/${year}/${JSON.stringify(contractTypes)}?pagination=${JSON.stringify(query)}`);
			if (resp.status !== 200)
				dispatch({
					type: TYPES.CONTRACT_FEES_ERROR,
					payload: resp.data
				});

			let { data = [], errors = [] } = resp.data;
			data.forEach(o => o.id_type = `${o.markingTeamId}_${o.type}`);
			const dataCopy = cloneDeep(data);

			if (!exportData) {
				const updated = getState().fees.updated;
				data = data.map(o => {
					const matchData = updated.find(x => x.id_type === o.id_type);
					return matchData ? { ...o, ...matchData } : o;
				});
			}

			const payload = {
				data,
				dataCopy,
				errors
			};

			return dispatch({
				type: !exportData ? TYPES.CONTRACT_FEES_GET : TYPES.CONTRACT_FEES_GET_ALL,
				payload
			});
		} catch (err) {
			dispatch({
				type: TYPES.CONTRACT_FEES_ERROR,
				payload: { errors: [err.message] }
			});
		}
	};
};

export const addUpdateToFee = (field, val, row, updates = []) => {
	return dispatch => {
		try {
			let _updates;
			if (updates.filter(x => x.id_type === row.id_type).length > 0) {
				_updates = updates.map(x => {
					return x.id_type !== row.id_type ? x : { ...x, [field]: val };
				});
			} else {
				_updates = [...updates, row];
			}
			dispatch({
				type: TYPES.CONTRACT_FEES_ADD_UPDATE,
				payload: { 
					updates: _updates, 
					errors: [] 
				}
			});
		} catch (err) {
			dispatch({
				type: TYPES.CONTRACT_FEES_ERROR,
				payload: { 
					errors: [err.message] 
				}
			});
		}
	};
};

export const removeUpdate = (keyField, id, updates = []) => {
	return dispatch => {
		try {
			const _updates = updates.filter(update => update[keyField] !== id);
			dispatch({
				type: TYPES.CONTRACT_FEES_ADD_UPDATE,
				payload: { 
					updates: _updates, 
					errors: [] 
				}
			});
		} catch (err) {
			dispatch({
				type: TYPES.CONTRACT_FEES_ERROR,
				payload: { updates, errors: [err.message] }
			});
		}
	}
};

export const removeAllEdits = () => {
	return (dispatch, getState) => {
		const { fees: { dataCopy } } = getState();
		const data = cloneDeep(dataCopy);
		dispatch({
			type: TYPES.CONTRACT_FEES_REMOVE_ALL_EDITS,
			payload: {
				data
			}
		});
	};
};

export const clearAllFeesUpdates = () => dispatch => dispatch({ type: TYPES.CONTRACT_FEES_CLEAR_ALL_UPDATES, payload: {} });

export const saveUpdatedContractFees = (contractTypes, year, updates) => {
	return async dispatch => {
		try {
			if (updates.length <= 0)
				return dispatch({
					type: TYPES.CONTRACT_FEES_SAVE,
					payload: {
						message: 'Unable to Save Data',
						errors: ['No Changes to Save'],
						data: []
					}
				});

			let resp = await axios.put(`/api/v2/contracts/fees/${year}/${JSON.stringify(contractTypes)}`, { updates: updates });

			let payload = {
				...resp.data,
				data: resp.data.data.map(o =>
					Object.assign(o, {
						id_type: `${o.markingTeamId}_${o.type}`
					})
				)
			};

			return resp.status === 200 ? dispatch({ type: TYPES.CONTRACT_FEES_SAVE, payload }) : dispatch({ type: TYPES.CONTRACT_FEES_ERROR, payload });
		} catch (err) {
			console.error(err);
		}
	};
};

export const clearUpdateFeesErrors = () => dispatch =>
	dispatch({
		type: TYPES.CONTRACT_FEES_CLEAR,
		payload: { message: '', errors: [] }
	});
